/**
 * dateSelect 日期选择
 * @author 3173
 * @date 2020-01-21
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer } = framework_tool;
let { WizCol, WizRow } = component_tool;
import { DatePicker } from 'antd'
const { RangePicker } = DatePicker;
import moment from 'moment';

class DateSelect extends WizContainer {

  componentName = 'DateSelect';

  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : undefined,
      visible: false
    };
    this.defaultValue = []
  }

  _componentWillMount() {
    const { onChange } = this.props;
    if (this.props.value) {
      this.defaultValue.push(moment(this.props.value.startDate, 'YYYY-MM-DD HH:mm:ss'))
      this.defaultValue.push(moment(this.props.value.endDate, 'YYYY-MM-DD HH:mm:ss'))
      let _value = {
        startDate: new Date(this.props.value.startDate),
        endDate: new Date(this.props.value.endDate)
      };
      onChange && onChange(_value);
    }

  }

  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }


  /**
   * 将值反馈给Form
   */
  onChange = (dateValue) => {
    const { onChange } = this.props;
    let _value = {};
    if (dateValue[0] && dateValue[0]._d) {
      _value.startDate = dateValue[0]._d;
    }
    if (dateValue[1] && dateValue[1]._d) {
      _value.endDate = dateValue[1]._d;
    }
    this.setState({
      value: _value,
      date: new Date().getTime()
    }, () => {
      onChange && onChange(_value);
    });
  };


  _render() {
    const { placeholder, ...otherProps } = this.props;
    return (
      <RangePicker
        defaultValue={this.defaultValue}
        format="YYYY-MM-DD HH:mm:ss"
        showTime={true}
        onChange={this.onChange.bind(this)}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(DateSelect);
